import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=c127ff0c&scoped=true&"
import script from "./JobList.vue?vue&type=script&lang=ts&"
export * from "./JobList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c127ff0c",
  null
  
)

export default component.exports